import { Typography } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { routes } from '../../constants';
import { AuthBtns } from '../AuthBtns';
import { links } from './data';
import * as Styled from './Header.styles';
import HeaderMenu from './HeaderMenu';

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [prevPathname, setPrevPathname] = useState(pathname);

  if (pathname !== prevPathname) {
    setPrevPathname(pathname);
    setIsOpen(false);
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const handleNavLinkClick = useCallback(
    (event, link) => {
      const { sectionId, href } = link;

      setIsOpen(false);

      if (!sectionId) return;

      event.preventDefault();

      if (pathname === href) {
        document
          .getElementById(sectionId)
          ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        navigate(`${href}#${sectionId}`);
      }
    },
    [pathname, navigate],
  );

  return (
    <>
      <Styled.Header id="header" className="glass-border">
        <Styled.LogoBlock to={routes.home}>
          <Styled.Logo variant="logo" />
        </Styled.LogoBlock>

        <Styled.Links>
          {links.map((link) => {
            const isLinkActive = !link.sectionId && pathname === link.href;

            return (
              <Typography key={link.labelKey} variant="body16">
                <Styled.Link
                  to={link.href}
                  isLinkActive={isLinkActive}
                  onClick={(event) => handleNavLinkClick(event, link)}
                >
                  {t(link.labelKey)}
                </Styled.Link>
              </Typography>
            );
          })}
        </Styled.Links>

        <Styled.Buttons>
          <Styled.Auth>
            <AuthBtns />
          </Styled.Auth>

          <Styled.Burger isOpen={isOpen} onClick={toggleMenu} />
        </Styled.Buttons>
      </Styled.Header>

      <HeaderMenu isOpen={isOpen} onNavLinkClick={handleNavLinkClick} />
    </>
  );
};

export default Header;
